import * as React from "react";

// Import Needed Components
import BOHeader from "./BOHeader";
import BOSide from "./BOSide/BOSide";
import BOContent from "./BOContent";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";
import { isEqual } from "lodash";

const update = require("immutability-helper");

class BOMain extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      slide: {
        sideDisabled: false,
        sideOpen: true,
        sideOptions: {}
      },
      breadCrumbs: [],
      savedStates: {},
      header: {}
    };

    this.toggleSlideSide = this.toggleSlideSide.bind(this);
    this.setSideOptions = this.setSideOptions.bind(this);
    this.toggleSideDisabled = this.toggleSideDisabled.bind(this);
    this.setBreadCrumbs = this.setBreadCrumbs.bind(this);
    this.addToStates = this.addToStates.bind(this);
  }

  toggleSideDisabled() {
    this.setState({
      slide: {
        sideOpen: this.state.slide.sideOpen,
        sideDisabled: !this.state.slide.sideDisabled,
        sideOptions: this.state.slide.sideOptions
      }
    });
  }

  toggleSlideSide() {
    this.setState({
      slide: {
        sideOpen: !this.state.slide.sideOpen,
        sideDisabled: this.state.slide.sideDisabled,
        sideOptions: this.state.slide.sideOptions
      }
    });
  }

  setSideOptions(options: any) {
    this.setState({
      slide: {
        sideOpen: this.state.slide.sideOpen,
        sideDisabled: this.state.slide.sideDisabled,
        sideOptions: options
      }
    });
  }

  setBreadCrumbs(BC: any) {
    this.setState({
      breadCrumbs: BC
    });
  }

  setHeader(header: { title: string; description: string }) {
    if (!isEqual(this.state.header, header)) {
      this.setState({
        header
      });
    }
  }

  addToStates(stateName: any, stateValue: any) {
    this.setState(
      update(this.state, {
        savedStates: {
          [stateName]: {
            $set: stateValue
          }
        }
      })
    );
  }

  clearStates() {
    this.setState({
      savedStates: []
    });
  }

  render() {
    return (
      <section id="BackOffice">
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <BOHeader
            {...this.state.slide.sideDisabled}
            header={this.state.header}
            toggleSlideSide={() => this.toggleSlideSide()}
          />
          <section id="BOMain">
            <BOSide {...this.props} />
            <BOContent
              {...this.state.slide}
              savedStates={this.state.savedStates}
              store_data={this.props.store_data}
              {...this.props}
              setBreadCrumbs={BC => this.setBreadCrumbs(BC)}
              setHeader={HD => this.setHeader(HD)}
              addToStates={(stateName, stateValue) =>
                this.addToStates(stateName, stateValue)
              }
            />
          </section>
        </MuiPickersUtilsProvider>
      </section>
    );
  }
}

export default BOMain;
